import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "plan-content" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"plan-info\"><h4 class=\"d-flex align-items-end gap-5\"><span>Coverage Options</span><i class=\"iatse-icon-info-tooltip\"></i><span class=\"tooltip-wrapper d-flex align-items-end\"><i class=\"iatse-icon-info-tooltip icon_rotate_0\"></i><p class=\"tooltip-text tooltip-text_secondary tooltip-text__large\"> Click on contribution period in this “Coverage” column to see the associated work month in the “Days Worked” column. Click the up/down arrows to change the range of work months and the coverage period. Click the work month to see corresponding contributions. </p></span></h4><h5> Your Coverage selection and pay applicable payment is due no longer than 06/17/2024 for the coverege period starting 07/01/2024 </h5></div>", 1)
const _hoisted_3 = {
  id: "make-coverage-form",
  class: "form make-coverage",
  method: "post"
}
const _hoisted_4 = { class: "bordered-card" }
const _hoisted_5 = { class: "bordered-card-header" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "bordered-card-body" }, [
  /*#__PURE__*/_createElementVNode("h4", null, [
    /*#__PURE__*/_createTextVNode(" C1 Single "),
    /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-info-tooltip" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "bordered-card green-card" }, [
    /*#__PURE__*/_createElementVNode("h6", null, " Amount Owned"),
    /*#__PURE__*/_createElementVNode("h4", null, " $ 799.00 ")
  ])
], -1)
const _hoisted_7 = { class: "bordered-card" }
const _hoisted_8 = { class: "bordered-card-header" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "bordered-card-body" }, [
  /*#__PURE__*/_createElementVNode("h4", null, [
    /*#__PURE__*/_createTextVNode(" C1 Single "),
    /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-info-tooltip" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "bordered-card green-card" }, [
    /*#__PURE__*/_createElementVNode("h6", null, " Amount Owned"),
    /*#__PURE__*/_createElementVNode("h4", null, " $ 799.00 ")
  ])
], -1)
const _hoisted_10 = { class: "bordered-card" }
const _hoisted_11 = { class: "bordered-card-header" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "bordered-card-body" }, [
  /*#__PURE__*/_createElementVNode("h4", null, [
    /*#__PURE__*/_createTextVNode(" C1 Single "),
    /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-info-tooltip" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "bordered-card green-card" }, [
    /*#__PURE__*/_createElementVNode("h6", null, " Amount Owned"),
    /*#__PURE__*/_createElementVNode("h4", null, " $ 799.00 ")
  ])
], -1)
const _hoisted_13 = { class: "bordered-card" }
const _hoisted_14 = { class: "bordered-card-header" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "bordered-card-body" }, [
  /*#__PURE__*/_createElementVNode("h4", null, [
    /*#__PURE__*/_createTextVNode(" C1 Single "),
    /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-info-tooltip" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "bordered-card green-card" }, [
    /*#__PURE__*/_createElementVNode("h6", null, " Amount Owned"),
    /*#__PURE__*/_createElementVNode("h4", null, " $ 799.00 ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessageCard = _resolveComponent("MessageCard")!
  const _component_SwitchInput = _resolveComponent("SwitchInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_MessageCard, {
      message: "Select a coverage option from the offerings below by clicking the applicable box. Failure to male a selection will result in the fund determining your enrollment for the upcoming quarter.",
      type: "primary",
      iconClass: "iatse-icon-alarm"
    }),
    _hoisted_2,
    _createElementVNode("form", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_SwitchInput, {
            option1: "Single",
            option2: "Family"
          })
        ]),
        _hoisted_6,
        _createElementVNode("a", {
          class: "btn btn-primary plan-modal",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.openModal('make-co-payment', 'Make CAPP Co-payment', 'plan-card-info')), ["prevent"]))
        }, " Continue this Coverage ")
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_SwitchInput, {
            option1: "Single",
            option2: "Family"
          })
        ]),
        _hoisted_9,
        _createElementVNode("a", {
          class: "btn btn-primary plan-modal",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.openModal('make-co-payment', 'Make CAPP Co-payment', 'plan-card-info')), ["prevent"]))
        }, " Continue this Coverage ")
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_SwitchInput, {
            option1: "Single",
            option2: "Family"
          })
        ]),
        _hoisted_12,
        _createElementVNode("a", {
          class: "btn btn-primary plan-modal",
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.openModal('make-co-payment', 'Make CAPP Co-payment', 'plan-card-info')), ["prevent"]))
        }, " Continue this Coverage ")
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_SwitchInput, {
            option1: "Single",
            option2: "Family"
          })
        ]),
        _hoisted_15,
        _createElementVNode("a", {
          class: "btn btn-primary plan-modal",
          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.openModal('make-co-payment', 'Make CAPP Co-payment', 'plan-card-info')), ["prevent"]))
        }, " Continue this Coverage ")
      ])
    ])
  ]))
}